"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.tagStyles = exports.statusToneMap = exports.tagToneStyles = void 0;
const lit_1 = require("lit");
const utils_1 = require("@/utils");
const categoryTone = (token) => {
    const borderColor = `var(--category-${token}-border-color)`;
    return {
        background: `var(--category-${token}-background-color)`,
        textColor: `var(--category-${token}-text-color)`,
        border: `var(--border-width) solid ${borderColor}`,
        borderColor,
    };
};
const defineToneMap = (map) => map;
/**
 * --------------------------------------------------
 * primitive visual tones
 * purely visual layer
 * --------------------------------------------------
 */
exports.tagToneStyles = {
    default: {
        background: 'var(--background-color)',
        textColor: 'var(--foreground-color)',
        border: 'var(--border)',
        borderColor: 'var(--border-color)',
    },
    gold: {
        background: 'var(--accent-color)',
        textColor: 'var(--gray800)',
        border: 'var(--border-transparent)',
        /* 테두리는 투명하지만, 색만 쓰는 곳은 같은 계열인 yellow의 값을 따른다. */
        borderColor: 'var(--category-6-border-color)',
    },
    green: categoryTone(2),
    yellow: categoryTone(6),
    red: categoryTone(7),
    blue: categoryTone(1),
    purple: categoryTone(8),
    pink: categoryTone(3),
    orange: categoryTone(4),
    cyan: categoryTone(5),
};
exports.statusToneMap = defineToneMap({
    success: 'green',
    warning: 'yellow',
    error: 'red',
    info: 'blue',
    neutral: 'default',
});
/**
 * --------------------------------------------------
 * component styles
 * --------------------------------------------------
 */
const tagToneTokens = Object.fromEntries(Object.entries(exports.tagToneStyles).map(([tone, style]) => [
    tone,
    {
        '--tag-background-color': style.background,
        '--tag-text-color': style.textColor,
        '--tag-border': style.border,
    },
]));
exports.tagStyles = (0, lit_1.css) `
  :host {
    --tag-height: var(--size-24);
    --tag-padding-inline: var(--space-2);
    --tag-gap: var(--space-1);
    --tag-border: var(--border);
    --tag-border-radius: var(--radius);
    --tag-background-color: var(--background-color);
    --tag-text-color: var(--foreground-color);
    --tag-text-size: var(--font-size-12);

    display: inline-flex;
    align-items: center;
    /* baseline 정렬이면 첫 자식(글자 없는 아이콘 등)에 따라 줄 위치가 달라지므로 자기 중앙으로 맞춘다. */
    vertical-align: middle;
    width: fit-content;
    min-height: var(--tag-height);
    gap: var(--tag-gap);
    padding-inline: var(--tag-padding-inline);
    border: var(--tag-border);
    border-radius: var(--tag-border-radius);
    box-sizing: border-box;
    background-color: var(--tag-background-color);
    color: var(--tag-text-color);
    white-space: nowrap;
    font-size: var(--tag-text-size);
    line-height: 1;
  }

  ${(0, lit_1.unsafeCSS)((0, utils_1.buildAttributeRules)('tone', tagToneTokens))}
`;
//# sourceMappingURL=data:application/json;base64,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